import React, { useEffect } from 'react';
import Header from '../Header/Header';
import './About.css'

import AOS from 'aos';
import 'aos/dist/aos.css';

const About = () => {

    useEffect(()=>{
        AOS.init({duration:1500})
    })

    return (
        <div>
            <Header></Header>
            <div className="about ">
                <div className="container">
                    <div className="row " data-aos="fade-right">
                        <div className="col-md-4 col-sm-12 col-12 text-center">
                            <div className="image">
                                <img src="https://i.postimg.cc/NfbHkTry/riyaz.jpg" alt="" />
                            </div>
                        </div>
                        <div className="col-md-8 col-sm-12 col-12">
                            <div className="col-md-12 col-sm-12 col-12">
                                <h1> Hi, I am <span id="nam">Riyaz Hossain</span></h1>
                                <h5>
                                    I am a frontend web developer and dynamic web designer. I can provide clean code and pixel perfect design. I also make website more and more interactive with web animations. I used latest technology for design.
                            </h5>
                            </div>
                            <div className="row">
                                <div className="col-md-2 col-sm-2.5 col-4">
                                    <div>
                                        <p>Name</p>
                                        <p>Languages</p>
                                        <p>Freelance</p>
                                        <p>E-mail</p>
                                        <p>Phone</p>
                                    </div>
                                </div>
                                <div className="col-md-.5 col-sm-.5 col-.5">
                                    <div>
                                        <p>:</p>
                                        <p>:</p>
                                        <p>:</p>
                                        <p>:</p>
                                        <p>:</p>
                                    </div>
                                </div>
                                <div className="col-md-9.5 col-sm-8 col-6">
                                    <div>
                                        <p>Riyaz Hossain</p>
                                        <p>Bengali, English</p>
                                        <p>Available</p>
                                        <p>mdriyaz5965@gmail.com</p>
                                        <p>+880177122595</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;